<template>
  <div class="comInvitationDialog-dialog-box pb-1" v-if="show">
    <div class="dialog-content">
      <div class="dialog-title mb-0">{{ title }}</div>
      <div class="dialog-label mb-0">{{ label }}</div>
      <div class="dialog-input mb-1">
        <input v-model="password" :placeholder="placeholder" />
      </div>
      <div class="dialog-buttons">
        <TianshengButton class="dialog-button" round @click="handleConfirm">{{
          confirmText
        }}</TianshengButton>
        <!-- <button class="dialog-button confirm" @click="handleConfirm">
          {{ confirmText }}
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      title: "",
      label: "",
      confirmText: "",
      cancelText: "",
      resolve: null,
      password: "",
      placeholder: "",
    };
  },
  methods: {
    open({ title, confirmText, label, cancelText, placeholder, password }) {
      this.title = title || "提示";
      this.label = label || "1";
      this.confirmText = confirmText || "确认";
      this.cancelText = cancelText || "取消";
      this.show = true;
      this.placeholder = placeholder || "请输入邀请人地址";
      this.password = password || "";
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    handleConfirm() {
      this.show = false;
      this.resolve && this.resolve(this.password);
    },
    handleCancel() {
      this.show = false;
      this.resolve && this.resolve(false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./index.scss");
</style>